import React from 'react';
import ServicePage from '../../components/ServicePage';
import { SearchCode, Globe, HardDrive, Router, Cog, Cloud, ListChecks, FileText, Wrench, Search, BarChart } from 'lucide-react';

export default function VulnScan() {
  return (
    <ServicePage
      title="漏洞扫描服务"
      subtitle="CVE/CNVD 双库引擎 · 识别准确率 ≥ 98% · 新漏洞 48H 内覆盖"
      description="卓迈漏洞扫描服务基于 CVE + CNVD 双库融合引擎，覆盖 Web、主机、网络设备、工控资产全类型，漏洞识别准确率 ≥ 98%，误报率 < 2%。支持一次性扫描和持续订阅两种模式——新漏洞（含国内 0day/1day）披露后 48 小时内完成全资产覆盖扫描，让你永远不是最后一个知道漏洞的人。"
      icon={<SearchCode size={40} strokeWidth={1.5} />}
      color="#0aab6e"
      benefits={[
        'CVE + CNVD 双库融合，覆盖国内外漏洞',
        '漏洞识别准确率 ≥ 98%，误报率 < 2%',
        '新漏洞披露后 48 小时内完成覆盖扫描',
        '支持持续订阅模式，持续守护而非一次性',
        '漏洞按业务影响优先级排序，而非 CVSS 堆表格',
      ]}
      features={[
        {
          icon: <Globe size={24} />,
          title: 'Web 应用漏洞扫描',
          desc: '覆盖 OWASP Top 10 全类型，支持登录态扫描（需提供测试账号），识别 SQL 注入、XSS、CSRF、文件上传、目录遍历等 200+ 种漏洞特征，误报率 < 2%。',
          points: ['OWASP Top 10 全覆盖', '登录态深度扫描', '200+ 漏洞特征库', '误报率 < 2%'],
        },
        {
          icon: <HardDrive size={24} />,
          title: '主机基线核查',
          desc: '对标 CIS Benchmark 和等保 2.0 基线要求，检查操作系统补丁缺失、账号权限配置、SSH/RDP 安全策略、服务最小化原则等 300+ 项安全基线，输出逐项对标报告。',
          points: ['CIS Benchmark 对标', '等保 2.0 基线适配', '300+ 基线检查项', '修复建议逐项说明'],
        },
        {
          icon: <Router size={24} />,
          title: '网络设备安全审计',
          desc: '支持华为、H3C、思科、Juniper 等主流品牌，扫描路由器、交换机、防火墙、负载均衡的固件版本漏洞和配置风险，识别明文协议、默认口令、弱访问控制等高危配置。',
          points: ['国产+进口设备全覆盖', '固件版本漏洞识别', '配置风险深度审计', '弱口令自动检测'],
        },
        {
          icon: <Cog size={24} />,
          title: '工控资产安全评估',
          desc: '针对 SCADA、PLC、DCS 等工控系统的非侵入式扫描，识别工控协议（Modbus/DNP3/IEC 104）暴露面，规避生产影响，适配电力、化工、水务等高安全要求场景。',
          points: ['非侵入式工控扫描', 'Modbus/DNP3/IEC104 协议', '零生产影响设计', 'OT/IT 融合资产识别'],
        },
        {
          icon: <Cloud size={24} />,
          title: '云资产与容器安全',
          desc: '覆盖主流公有云资产，以及 Docker、Kubernetes 容器环境，识别安全组配置错误、公开存储桶、K8s RBAC 配置不当等云原生漏洞。',
          points: ['主流公有云全覆盖', 'K8s RBAC 安全评估', 'Docker 容器逃逸检测', '云存储暴露面扫描'],
        },
        {
          icon: <ListChecks size={24} />,
          title: '优先级排序修复报告',
          desc: '不只堆 CVE 表格——所有漏洞结合业务场景做二次优先级排序：哪个漏洞被攻击者利用的可能性最高、业务影响最大，优先修哪个，并提供具体修复步骤和参考补丁链接。',
          points: ['业务影响优先级排序', 'CVSS + 可利用性评估', '修复步骤逐项说明', '补丁链接直接附带'],
        },
      ]}
      process={[
        { icon: <FileText size={24} />, title: '资产盘点', desc: '梳理扫描目标清单，确认 IP 段、域名、应用范围，签署扫描授权书' },
        { icon: <Wrench size={24} />, title: '方案制定', desc: '根据资产类型选择扫描策略（轻量/深度/认证扫描），制定扫描时间窗口' },
        { icon: <Search size={24} />, title: '执行扫描', desc: '多引擎并行扫描，实时去重降噪，平均 500 资产 4 小时完成全扫' },
        { icon: <BarChart size={24} />, title: '人工研判', desc: '专家对高危结果逐一验证，剔除误报，补充人工发现的逻辑漏洞' },
        { icon: <ListChecks size={24} />, title: '报告交付', desc: '提交分级修复报告 + 管理层摘要，免费提供首次修复验证复测' },
      ]}
      nextService={{ name: '代码审计服务', path: '/services/code-audit' }}
    />
  );
}
